<ul class="fa-ul mb-0 ms-3 usp-block" wlCSCapture>
  @for (usp of usps(); track $index) {
    <li>
      <fa-icon
        class="fa-li text-success"
        [class.text-body-secondary]="usp.inactive"
        [icon]="usp.inactive ? 'times' : 'check'"
      ></fa-icon>
      <span [class.text-body-secondary]="usp.inactive" class="me-1">{{
        usp.text
      }}</span>
      @if (usp.tooltip) {
        <wl-tooltip [tooltip]="tooltip(usp)"></wl-tooltip>
      }
    </li>
  }
</ul>
